import React, { useState, useContext } from 'react';
import { Header, Container, Segment, Grid, Divider, Radio, Checkbox } from 'semantic-ui-react';
import { List, Label, Button, Icon, Modal, Select, Form, Dropdown, Menu } from 'semantic-ui-react';
import { Link, useParams, Redirect } from 'react-router-dom';
import { AppState } from '../context';
import { Loader, Dimmer } from 'semantic-ui-react';
import { dbPending, dbFamMember, dbFamtoFam, dbTasks, dbCaregivers } from '../firebase';
import firebase from 'firebase/app';
import 'firebase/functions';
import TopMenu from './TopMenu';
import DatetoTime from '../DatetoTime';
import { stat } from 'fs';

const Summary = () => {
  const sendText = firebase.functions().httpsCallable('sendText');

  async function sendSMSFamilyMember(taskID) {

    var number2 = "";
    if (famtofam && familyMembers) {
      var taskname = famtofam[taskID]['taskName']
      var description = famtofam[taskID]['description']
      var time = famtofam[taskID]['time']
      var importance = famtofam[taskID]['importance']
      var freq = famtofam[taskID]['frequency']


      var c = "Task: " + taskname + " at approximately " + time + "Description: " + description + "Importance: "
        + importance + "Frequency: " + freq;
      console.log(c)


      number2 = familyMembers[famtofam[taskID]['AssignedtoFam']]['phone']


      let tempe = { to: number2, body: c };
      console.log(tempe)
      sendText({ data: tempe });
    }

  }


  async function sendSMSCaregiver(taskID) {

    var number2 = "";
    dbTasks.child(taskID).once('value').then(function (temp) {
      var taskname = temp.val().taskName
      var duration = temp.val().duration
      var description = temp.val().description;
      var time = temp.val().time;
      var importance = temp.val().importance;
      var freq = temp.val().frequency;


      var c = "Make sure to complete the " + taskname + " task at approximately " + time + ". This is a " + importance +" importance task. Thank you!" 

       

      dbCaregivers.child(temp.val().caregiverId).child("phone").once("value", function (snapshot) {
        number2 = snapshot.val()

      }, function (errorObject) {
        console.log("The read failed: " + errorObject.code);
      });
      let tempe = { to: number2, body: c };
      console.log(tempe)
      sendText({ data: tempe });
    });
  }

  const someContext = useContext(AppState);
  const {
    globallogged,
    deletetoggle,
    setDeleteToggle,
    filter,
    setFilter,
    pending,
    familyMembers,
    tasks,
    caregivers,
    famtofam,
    filtercaregiver,
    setFilterCaregiver,
    filter2nd,
    setFilter2nd,
    filterAll,
    setFilterAll,
    filtermine,
    setFilterMine,
    filterunassigned,
    setFilterunassigned,
  } = someContext;


  const [loader, setLoader] = useState(true);
  const [todayDate, setDate]=useState(new Date())
  const [todayString, setTodayString]=useState(todayDate.toString())
  const [BoolAll, setBoolAll]=useState(false)
  const [today,setToday]=useState("Today")

  setTimeout(() => { setLoader(false) }, 500)
  let { userid } = useParams();

  function EachItem1({ id }) {
    function Remove_click(id) {
      if (tasks) {
        if (Object.keys(familyMembers[userid]["tasks"]).length > 1) {
          dbFamMember.child(userid).child("tasks").child(id).remove();
          if (tasks && tasks[id]) {
            var temp = tasks[id]['caregiverId']
            dbCaregivers.child(temp).child("tasks").child(id).remove();
          }
          // Removes the task from the Task database.
          dbTasks.child(id).remove();
        }
      }
    }

    var temp = DatetoTime(tasks[id]["statusLastChecked"]);
    function testToday(){
      if(tasks[id]['duebydate']){

      
      var date= new Date(tasks[id]['duebydate']);
      var arry=date.toString().split(" ");
      console.log("this is the date")
      console.log(arry);
      console.log(todayString.toString().split(" "));
      if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
        console.log('correctomondo')
        return true;
      }
      var createdonDate=new Date(tasks[id]['createdOn'])
      console.log(createdonDate)
      var todaystime= new Number(todayDate)
      var timedue= new Number(tasks[id]['duebydate'])
      if(date.getDay() == todayDate.getDay() && tasks[id]['frequency']=="Weekly" && todaystime>=timedue){
        return true;
      }
      else if(tasks[id]['frequency']==="Everyday" || tasks[id]['frequency']==="Twice a Day" && todaystime>=timedue ){
        return true;
      }
      else{
        console.log(todayString);
        return false;
      }
    }
    else{
      return true;
    }
    }
    if(testToday() || BoolAll){

   
    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' color='green' ribbon>
              Completed by {tasks && familyMembers ? caregivers[tasks[id]["caregiverId"]]["firstName"] : ""}
            </Label>
            <span><strong>{tasks ? tasks[id]["taskName"] : ""}</strong></span>
            {deletetoggle ?
              <Button icon="close" color="red" size="mini" floated="right" onClick={() => Remove_click(id)} >
              </Button>
              : ""}
            {deletetoggle ?
              <Button icon="pencil alternate" color="blue" size="mini" floated="right" as={Link} to={`/familymembers/edit/${id}`}>
              </Button>
              : ""}
            {/* <List.Item> <strong>Description:</strong> {tasks ? tasks[id]["description"] : ""}</List.Item> */}
            {/* <List.Item> <strong>Duration:</strong> {tasks ? tasks[id]["duration"] : ""}</List.Item> */}
            {/* <List.Item> <strong>Caregiver Notes:</strong> {"137/84, Pulse: 65"}</List.Item> */}
            <List.Item> <strong>Due at:</strong> {tasks ? tasks[id]["time"] : ""}</List.Item>
            <List.Item> <strong>Completed On: </strong> {tasks ? temp : ""}</List.Item>

          </Segment>
        </Grid.Column>
      </Grid.Row>);
       }
       else{
         return ""
       }
  }
  function EachItem2({ id }) {
    function Remove_click(id) {
      if (tasks) {
        if (Object.keys(familyMembers[userid]["tasks"]).length > 1) {
          dbFamMember.child(userid).child("tasks").child(id).remove();
          if (tasks && tasks[id]) {
            var temp = tasks[id]['caregiverId']
            dbCaregivers.child(temp).child("tasks").child(id).remove();
          }
          // Removes the task from the Task database.
          dbTasks.child(id).remove();
        }
      }
    }

    var temp;

    temp = DatetoTime(tasks[id]["createdOn"]);
    const [reminder, setReminder] = useState(true);
    const [loading, setLoading] = useState(false)
    function Reminder(id) {
      sendSMSCaregiver(id)
      setReminder(false)
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
      }, 600);
    }

    function testToday(){
      if(tasks[id]['duebydate']){
      var date= new Date(tasks[id]['duebydate']);
      var arry=date.toString().split(" ");
      console.log("this is the date")
      console.log(arry);
      console.log(todayString.toString().split(" "));
      if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
        console.log('correctomondo')
        return true;
      }
      var createdonDate=new Date(tasks[id]['createdOn'])
      console.log(createdonDate)
      var todaystime= new Number(todayDate)
      var timedue=  new Number(tasks[id]['duebydate'])
      if(date.getDay() == todayDate.getDay() && id['frequency']=="Weekly"  && todaystime>=timedue){
        return true;
      }
      else if((tasks[id]['frequency']==="Everyday" || tasks[id]['frequency']==="Twice a Day" )&& todaystime>=timedue){
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return true;
    }
    }
    if(testToday() || BoolAll){

    

    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' ribbon>
              Incomplete - {tasks && familyMembers ? caregivers[tasks[id]["caregiverId"]]["firstName"] : ""}
            </Label>
            <span><strong>{tasks ? tasks[id]["taskName"] : ""}</strong></span>
            {deletetoggle ?
              <Button icon="close" color="red" size="mini" floated="right" onClick={() => Remove_click(id)} >
              </Button>
              : ""}
            {deletetoggle ?
              <Button icon="pencil alternate" color="blue" size="mini" floated="right" as={Link} to={`/familymembers/edit/${id}`}>
              </Button>
              : ""}
            {/* <List.Item> <strong>Description:</strong> {tasks ? tasks[id]["description"] : ""}</List.Item> */}
            <List.Item> <strong>Due at: </strong> {tasks ? tasks[id]["time"] : ""}</List.Item>
            <List.Item> <strong>Created On: </strong> {tasks ? temp : ""}</List.Item>

            {/* <List.Item> <strong>Duration:</strong> {tasks ? tasks[id]["duration"] : ""}</List.Item> */}
            <Button
              // attached='bottom'
              fluid='false'
              icon={reminder ? "share" : "checkmark"}
              loading={loading}
              content={reminder && tasks && familyMembers ? `Send reminder to ${caregivers[tasks[id]["caregiverId"]]["firstName"]}` : "Reminder sent"}
              style={{ marginTop: "10px" }}

              onClick={() => Reminder(id)}
            />
          </Segment>

        </Grid.Column>
      </Grid.Row>);
      }
      else{
        return ""
      }
  }
  function EachItemC1({ id, caregiverID }) {
    function Remove_click(id) {
      if (caregivers) {
        if (Object.keys(caregivers[caregiverID]["todolist"]).length > 1) {
          // dbFamMember.child(userID).child("tasks").child(status.input).remove();
          // Removes the task from the Task database.
          // dbTasks.child(status.input).remove();
          temp = caregivers[caregiverID]["todolist"]
          temp.splice(id, 1);
          dbCaregivers.child(caregiverID).child('todolist').set(temp);
        }
      }
    }
    var temp;

    temp = DatetoTime(id["statusLastChecked"]);


    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' color='green' ribbon>
              Completed
        </Label>
            <span><strong>{id ? id["type"] : ""}</strong></span>
            {deletetoggle ?
              <Button icon="close" color="red" size="mini" floated="right" onClick={() => Remove_click(id)}>
              </Button>
              : ""}
            <List.Item> <strong>Description:</strong> {id ? id["detail"] : ""}</List.Item>
            <List.Item> <strong>Completed on :</strong> {id ? temp : ""}</List.Item>
            {/* <List.Item> <strong>Caregiver Notes:</strong> {"137/84, Pulse: 65"}</List.Item> */}
          </Segment>
        </Grid.Column>
      </Grid.Row>);
  }
  function EachItemC2({ id, caregiverID }) {
    function Remove_click(id) {
      if (caregivers) {
        if (Object.keys(caregivers[caregiverID]["todolist"]).length > 1) {
          // dbFamMember.child(userID).child("tasks").child(status.input).remove();
          // Removes the task from the Task database.
          // dbTasks.child(status.input).remove();
          temp = caregivers[caregiverID]["todolist"]
          temp.splice(id, 1);
          dbCaregivers.child(caregiverID).child('todolist').set(temp);
        }
      }
    }
    var temp;

    temp = DatetoTime(id["createdOn"]);

    

    if (!id['sample']) {
      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' ribbon>
                Incomplete
        </Label>
              <span><strong>{id ? id["type"] : ""}</strong></span>
              {deletetoggle ?
                <Button icon="close" color="red" size="mini" floated="right" onClick={() => Remove_click({ id })}>
                </Button>
                : ""}
              <List.Item> <strong>Description:</strong> {id ? id["detail"] : ""}</List.Item>
              <List.Item> <strong>Assigned on :</strong> {id ? temp : ""}</List.Item>
              {/* <List.Item> <strong>Duration:</strong> {id ? id["time"] : ""}</List.Item> */}

            </Segment>
          </Grid.Column>
        </Grid.Row>);


    }
    return ("")
  }
  function EachItemF1({ id }) {
    const [reminder, setReminder] = useState(true);
    const [loading, setLoading] = useState(false)
    function Remove_click(status) {
      console.log(status);
      if (famtofam) {
        // if (Object.keys(familyMembers[userID]["tasks"]).length > 1) {
        //   dbFamMember.child(userID).child("tasks").child(status.input).remove();
        //   // Removes the task from the Task database.
        //   dbTasks.child(status.input).remove();
        dbFamMember.child(famtofam[id]['AssignedtoFam']).child('tasksfromfam').child(id).remove();
        dbFamMember.child(famtofam[id]['AssignedbyFam']).child('taskstofam').child(id).remove();
        dbFamtoFam.child(id).remove();

      }
    }
    function testToday(){
      if(famtofam[id]['duebydate']){

      
      var date= new Date(famtofam[id]['duebydate']);
      var arry=date.toString().split(" ");
      console.log("this is the date")
      console.log(arry);
      console.log(todayString.toString().split(" "));
      if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
        console.log('correctomondo')
        return true;
      }
      var createdonDate=new Date(famtofam[id]['createdOn'])
      console.log(createdonDate)
      
      var todaystime= new Number(todayDate)
      var timedue=  new Number(famtofam[id]['duebydate'])
      if(date.getDay() == todayDate.getDay() && famtofam[id]['frequency']=="Weekly" && todaystime>=timedue ){
        return true;
      }
      else if((famtofam[id]['frequency']==="Everyday" || famtofam[id]['frequency']==="Twice a Day" )&& todaystime>=timedue){
        return true;
      }

      else{
        return false;
      }
    }
    else{
      return true;
    }
    }
    if(!testToday() && !BoolAll){
      return "";
    }
    if (famtofam[id]["status"]) {
      var temp;
      temp = DatetoTime(famtofam[id]["statusLastChecked"]);

      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' color='green' ribbon>
                Completed by {famtofam && familyMembers ? familyMembers[famtofam[id]["AssignedtoFam"]]["firstName"] : ""}
              </Label>
              <span><strong>{famtofam ? famtofam[id]["taskName"] : ""}</strong></span>
              {deletetoggle ?
                <Button icon="close" color="red" size="mini" floated="right" onClick={() => Remove_click(famtofam[id])}>
                </Button>
                : ""}
              <List.Item> <strong>Due at:</strong> {famtofam ? famtofam[id]["time"] : ""}</List.Item>
              <List.Item> <strong>Completed  on:</strong> {temp} <strong>by </strong> {famtofam && familyMembers ? familyMembers[famtofam[id]["AssignedtoFam"]]["firstName"] : ""}</List.Item>
              {/* <List.Item> <strong>Assigned  on:</strong> {temp} <strong>by </strong>  </List.Item> */}

              {/* <List.Item> <strong>Duration:</strong> {famtofam ? famtofam[id]["duration"] : ""}</List.Item> */}
              {/* <List.Item> <strong>Caregiver Notes:</strong> {"137/84, Pulse: 65"}</List.Item> */}
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else if (!famtofam[id]["status"]) {
      var temp;
      temp = DatetoTime(famtofam[id]["createdOn"]);

      function Reminder(id) {
        sendSMSFamilyMember(id)
        setReminder(false)
        setLoading(true)
        setTimeout(() => {
          setLoading(false)
        }, 600);
      }
      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' ribbon>
                Incomplete {famtofam[id]["AssignedtoFam"] !== userid ? `by ${familyMembers && familyMembers[famtofam[id]["AssignedtoFam"]] ? familyMembers[famtofam[id]["AssignedtoFam"]]["firstName"] : ""}`
                  : " - Your Task"}
              </Label>
              <span><strong>{famtofam ? famtofam[id]["taskName"] : ""}</strong></span>
              {deletetoggle ?
                <Button icon="close" color="red" size="mini" floated="right" onClick={() => Remove_click(famtofam[id])}>
                </Button>
                : ""}
              <List.Item> <strong>Due at:</strong> {famtofam ? famtofam[id]["time"] : ""}</List.Item>
              <List.Item> <strong>Assigned  on:</strong> {temp} <strong>by </strong>  {famtofam && familyMembers ? familyMembers[famtofam[id]["AssignedbyFam"]]["firstName"] : ""}</List.Item>

              {/* <List.Item> <strong>Duration:</strong> {tasks ? tasks[id]["duration"] : ""}</List.Item> */}
              {famtofam[id]["AssignedtoFam"] !== userid ? <Button
                fluid="true"
                icon={reminder ? "share" : "checkmark"}
                loading={loading}
                content={reminder && famtofam && familyMembers && familyMembers[famtofam[id]["AssignedtoFam"]]? `Send reminder to ${familyMembers[famtofam[id]["AssignedtoFam"]]["firstName"]}` : "Reminder sent"}
                style={{ marginTop: "10px" }}
                onClick={() => Reminder(id)} />
                : ""}
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else {
      return null;
    }
  }
  function EachItemU1({ id }) {
    const [confirmmodal, setConfirmModal] = useState(false);
    function Remove_click(status) {
      console.log(status);
      if (pending) {
        dbPending.remove(id);
      }
    }


    function FirebaseRewrite() {
      if (familyMembers && pending[id] && pending[id]["AssignedbyFam"]) {
        temp = pending[id];
        temp["AssignedtoFam"] = userid;
        if (familyMembers[pending[id]["AssignedbyFam"]] && familyMembers[pending[id]["AssignedtoFam"]]) {
          console.log(id)
          if (Object.keys(pending).length > 1) {
            dbPending.child(id).remove();
            if (Object.values(familyMembers[userid]["unassignedTasks"]).length == 1) {
              dbFamMember.child(userid).child("unassignedTasks").child(id).remove()
              dbFamMember.child(userid).update({
                "unassignedTasks": "null",
              })
            }
            else {
              console.log(familyMembers[userid])
              dbFamMember.child(userid).child("unassignedTasks").child(id).remove()
            }
          }
          const dataToPush = {
            [id]: temp
          }
          dbFamtoFam.update(dataToPush);
          if (familyMembers[pending[id]["AssignedtoFam"]]["tasksfromfam"]) {
            dbFamMember.child(userid).child("tasksfromfam").update({
              [id]: id || null
            });
          }
          else {
            dbFamMember.child(userid).child("tasksfromfam").update({
              [id]: id || null
            });
          }
          if (familyMembers[pending[id]["AssignedbyFam"]]["taskstofam"] && familyMembers[pending[id]["AssignedbyFam"]] !== familyMembers[pending[id]["AssignedtoFam"]]) {
            dbFamMember.child(pending[id]["AssignedbyFam"]).child("taskstofam").update({
              [id]: id || null
            })
          }
          else if (familyMembers[pending[id]["AssignedbyFam"]] !== familyMembers[pending[id]["AssignedtoFam"]]) {
            dbFamMember.child(pending[id]["AssignedbyFam"]).child("taskstofam").update({
              [id]: id || null
            })
          }

        }
      }
      else {
        console.log("Doesnt work")
      }
      setConfirmModal(false);
    }
    if (pending[id]["status"]) {
      var temp = DatetoTime(pending[id]["createdOn"]);
      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' color='green' ribbon>Completed</Label>
              <strong>{pending ? pending[id]["taskName"] : ""}</strong>
              <List.Item> <strong>Description:</strong> {pending ? pending[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Completed on:</strong> {temp}</List.Item>
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else if (!pending[id]["status"]) {
      let temp = DatetoTime(pending[id]["createdOn"]);
      return (

        <Grid.Row>
          <Modal open={confirmmodal} size='small' closeOnEscape={true} basic >
            <Header icon='archive' />
            <Modal.Content>
              Do you want to add <strong>{pending ? pending[id]["taskName"] : ""}</strong> to your tasklist?
            </Modal.Content>
            <Modal.Actions>
              <Button basic color='red' inverted onClick={() => setConfirmModal(false)}>
                <Icon name='remove' /> No</Button>
              <Button color='green' inverted onClick={() => FirebaseRewrite()}>
                <Icon name='checkmark' /> Yes</Button>
            </Modal.Actions>
          </Modal>
          <Grid.Column>
            <Segment raised >
              {/* onClick={() => setConfirmModal(true)} */}
              <Label as='a' ribbon color='yellow'>
                Unassigned </Label>
              <span><strong>{pending ? pending[id]["taskName"] : ""}</strong></span> {deletetoggle ? <Button icon="close" color="red" size="mini" floated="right" onClick={() => Remove_click(pending[id])}></Button> : ""}

              <List.Item> <strong>Due at:</strong> {pending ? pending[id]["time"] : ""}</List.Item>
              <List.Item> <strong>Assigned  on:</strong> {temp} <strong> by </strong> {familyMembers ? familyMembers[pending[id]["AssignedbyFam"]]["firstName"] : ""}</List.Item>
              <Button
                content="Add to my tasks"
                icon="plus"
                fluid='true'
                onClick={() => setConfirmModal(true)}
                style={{ marginTop: "10px" }}
              />

            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else {
      return null;
    }
  }
  const TasksFromFam = () => {
    if (familyMembers[userid]["tasksfromfam"] && filtermine) {
      return (Object.values(familyMembers[userid]["tasksfromfam"]).map((id) =>
        <EachItemF1 id={id} />))
    }
     else {
      return null;
    }

  }
  const Options = [
    { key: 'All Tasks', value: 'All Tasks', text: 'All Tasks' },
    // { key: 'All Tasks', value: 'All Tasks', text: 'All Tasks' },
    { key: 'My Tasks', value: 'My Tasks', text: 'My Tasks' },
    { key: 'Caregiver(s) Tasks', value: 'Caregiver Tasks', text: 'Caregiver Tasks' },
    { key: 'Family Tasks', value: 'Family Tasks', text: 'Family Tasks' },
    { key: 'Unassigned Tasks', value: 'Unassigned Tasks', text: 'Unassigned Tasks' },
  ]
  const todayOptions = [
    {key: 1, value: "Today", text: "Today"},
    {key: 2, value: "All", text:"All"}
  ]

  function Loaded() {
    function Filtering(value) {
      setFilter(value)
      if (value == "All Tasks") {
        setFilter2nd(true);
        setFilterCaregiver(true);
        setFilterMine(true);
        setFilterunassigned(true);
        // setFilterAll(false);
      }
      // if (value == "All Tasks") {
      //   setFilter2nd(true);
      //   setFilterAll(true);
      //   setFilterCaregiver(true);
      //   setFilterMine(true);
      //   setFilterunassigned(true);
      // }
      else if (value == "My Tasks") {
        setFilter2nd(false);
        // setFilterAll(false);
        setFilterCaregiver(false);
        setFilterMine(true);
        setFilterunassigned(false);
      }
      else if (value == "Caregiver Tasks") {
        setFilter2nd(false);
        setFilterCaregiver(true);
        setFilterMine(false);
        // setFilterAll(false);
        setFilterunassigned(false);
      }
      else if (value == "Family Tasks") {
        setFilter2nd(true);
        setFilterCaregiver(false);
        setFilterMine(true);
        // setFilterAll(false);
        setFilterunassigned(false);
      }
      else if (value == "Unassigned Tasks") {
        setFilter2nd(false);
        setFilterCaregiver(false);
        // setFilterAll(false);
        setFilterMine(false);
        setFilterunassigned(true);
      }

    }
    function todayChange(value){
      
      if(value=="Today"){
        setBoolAll(false)
        setToday("Today")
      }
      else{
        setBoolAll(true)
        setToday("All")
      }
    }
    function hasNOTE(){
      if(familyMembers && familyMembers[userid] && familyMembers[userid]["caregivers"]){
        for (let i = 0; i< Object.values(familyMembers[userid]["caregivers"]).length; i++){
          if(caregivers[Object.values(familyMembers[userid]["caregivers"])[i]]['todolist'].length>1){
            return true;
          }
        }
      }
      else{
        return false;
      }
      

    }
    if (globallogged)
    {
    return (
      tasks && famtofam && caregivers ?
        <div>
          <TopMenu />
          <Container>
            <Grid padded>
              <Grid.Row>
                <Grid.Column width={8}>
                  <div style={{ marginTop: "0px", marginLeft: "0px", marginBottom: "0px", textAlign: "start" }}>
                    <Menu compact>
                      <Dropdown text={filter}
                        options={Options}
                        simple item
                        onChange={(e, { value }) => Filtering(value)} />
                    </Menu>
                  </div>
                </Grid.Column>
                <Grid.Column width={5}>
                  <div style={{ marginTop: "0px", marginLeft: "-10px", marginBottom: "0px", textAlign: "start" }}>
                    <Menu compact>
                      <Dropdown text={today}
                        options={todayOptions}
                        simple item
                        onChange={(e, { value }) => todayChange(value)} />
                    </Menu>
                  </div>
                </Grid.Column>
                <div style={{ marginTop: "10px", marginLeft: "0px", marginBottom: "0px" }}>
                  <Grid.Column width={3}>
                    <Checkbox toggle
                      value={'here'}
                      checked={deletetoggle}
                      onChange={(e, { value }) => setDeleteToggle(deletetoggle => !deletetoggle)}
                    />
                  </Grid.Column>
                </div>
              </Grid.Row>
              {/* <Grid padded> */}
              {/* <Grid.Row centered>
              <Header style={{ marginTop: '10px', marginBottom: '10px', textAlign: 'center' }} as='h4' textAlign="center">Unassigned</Header>
            </Grid.Row > */}
              {(familyMembers[userid]["unassignedTasks"] !== "null" && pending && filterunassigned) ? 
              
                  Object.values(familyMembers[userid]["unassignedTasks"]).map((id) =>
                        pending[id] ?
                          <EachItemU1 id={id} /> : null
                            )
                : filterunassigned&&!(filtermine) ? <Header>There are no unassigned tasks, i.e. tasks that haven't been designated to anyone</Header> : ""}
              {/* <Grid.Row centered>
              <Header style={{ marginTop: '10px', marginBottom: '10px', textAlign: 'center' }} as='h4' textAlign="center">Caregiver Tasks</Header>
            </Grid.Row> */}
              {filtercaregiver && familyMembers[userid]['careBool'] && Object.values(familyMembers[userid]["tasks"]).length>1 ? 
              ((Object.values(familyMembers[userid]["tasks"])).filter(i => (Object.values(familyMembers[userid]["sampletasks"]).indexOf(i) == -1))).map((id) =>
                !tasks[id]["status"] ? <EachItem2 id={id} /> : <EachItem1 id={id} />) 
                : filtercaregiver && !(filtermine)? <Header>There are no tasks for caregivers as yet</Header> : ""}
              {/* <Grid.Row centered>
              <Header style={{ marginTop: '10px', marginBottom: '10px', textAlign: 'center' }} as='h4' textAlign="center">Your Tasks</Header>
            </Grid.Row> */}
              {filtermine && familyMembers[userid]['careBool'] && hasNOTE() ? Object.values(familyMembers[userid]["caregivers"]).map((id) =>
                caregivers ? (Object.values(caregivers[id]["todolist"])).map((val) => val["status"] ? <EachItemC1 id={val} caregiverID={id} /> : <EachItemC2 id={val} caregiverID={id} />) : "") 
                :
                !hasNOTE() && !familyMembers[userid]['tasksfromfam']  && filtermine && !filter2nd? <Header>No tasks for you yet.</Header> : 
                console.log("No caregiver tasks yet!")}
              {/* <Grid.Row centered>
              <Header style={{ marginTop: '10px', marginBottom: '10px', textAlign: 'center' }} as='h4' textAlign="center">TasksFromFam</Header>
            </Grid.Row> */}
              <TasksFromFam />
              {/* <Grid.Row centered>
              <Header style={{ marginTop: '10px', marginBottom: '10px', textAlign: 'center' }} as='h4' textAlign="center">Other Family Member Tasks</Header>
            </Grid.Row > */}
              {familyMembers[userid]["secondaryFam"] !== "hi" && famtofam && filter2nd  && Object.values(familyMembers[userid]["taskstofam"]).length >1? Object.values(familyMembers[userid]["taskstofam"]).map((id) =>
                famtofam[id] ?
                  <EachItemF1 id={id} /> : null
              )
             
                :  
                  filter2nd && !filtercaregiver ? <Header>No tasks for other family members yet.</Header> : console.log("There are no secondry Family members yet!")}

            </Grid>
          </Container>
        </div> :
        <Dimmer active>
          <Loader size='huge'>Loading</Loader>
        </Dimmer>
    )}
    else{
      return <Redirect to={'/login'} push={true} />
    }
  }
  return (<div>
    {loader ?
      <Dimmer active>
        <Loader size='huge'>Loading</Loader>
      </Dimmer> : <Loaded />}
  </div>);
}

export default Summary;